export default "__VITE_ASSET__CWWS_gci__"